import { Link, useParams } from "react-router-dom";
import { findTool, accentClasses } from "../toolRegistry";

export default function ToolDetailPage() {
  const { toolId } = useParams();
  const match = toolId ? findTool(toolId) : null;

  if (!match || !match.tool.render) {
    return (
      <div>
        <Link to="/tools" className="text-brand-deep font-semibold">← Tools</Link>
        <p className="mt-4 text-ink-soft">Tool not found or not yet available.</p>
      </div>
    );
  }

  const { tool, category } = match;
  const accent = accentClasses[category.accent];

  return (
    <div>
      <Link to="/tools" className="text-brand-deep font-semibold">← Tools</Link>
      <div className="flex items-center gap-3 mt-3 mb-1">
        <span className={`w-10 h-10 rounded-sm2 ${accent.tint} flex items-center justify-center text-lg`}>{tool.icon}</span>
        <h2 className="font-extrabold text-[26px] tracking-tight">{tool.name}</h2>
      </div>
      <p className="text-ink-soft mb-5">{tool.description}</p>
      <div className="tool-panel">{tool.render?.()}</div>
    </div>
  );
}
